export default "__VITE_ASSET__1f22f3ce__"